//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { jaTestimonials, koTestimonials } from '@/data/testimonials/index.js';

export default {
  name: 'SubscribeTestimonials',
  components: {
    SubscribeTestimonialsItem: () => import('./SubscribeTestimonialsItem.vue'),
    SubscribeTestimonialsItemKo: () => import('./SubscribeTestimonialsItemKo.vue'),
  },
  data() {
    return {
      isShowAll: false,
      itemsToShow: 6,
      desktopBreakpoint: 1200,
    };
  },
  created() {
    this.itemsToShow = this.testimonials.itemsToShow;
    if (this.windowWidth >= this.desktopBreakpoint && this.$i18n.locale === 'ko') {
      this.isShowAll = true;
    }
  },
  computed: {
    ...mapState({
      windowWidth: state => state.browser.window.width,
    }),
    testimonials() {
      switch (this.$i18n.locale) {
        case 'ja':
          return {
            items: jaTestimonials,
            heading: 'ユーザーの声',
            class: '',
            component: 'SubscribeTestimonialsItem',
            itemsToShow: 6,
          };
        case 'ko':
          return {
            items: koTestimonials,
            heading: '고객 사례',
            class: 'testimonials-items-ko',
            component: 'SubscribeTestimonialsItemKo',
            itemsToShow: 3,
          };
        default:
          return null;
      }
    },
    testimonialsToShow() {
      if (!process.server && (this.windowWidth < this.desktopBreakpoint)) {
        return this.testimonials.items.slice(0, this.itemsToShow);
      }

      return this.testimonials.items;
    },
  },
  methods: {
    loadMore() {
      if (this.windowWidth >= this.desktopBreakpoint) {
        this.isShowAll = true;
      } else {
        this.itemsToShow += 6;
        if (this.testimonials.items.length < this.itemsToShow) {
          this.isShowAll = true;
        }
      }
    },
  },
};
